import React from "react";

/**
 * FadeIn — gates a region of UI behind a `ready` flag.
 *
 * Until `ready === true` the children are rendered with `visibility: hidden`
 * and `opacity: 0` (so they reserve no space-shift, never flash stale text,
 * and don't trigger empty-state messages prematurely). Once `ready` flips
 * true the region fades in over 120ms.
 *
 * Critically: the *layout* (heights, widths, scroll position) is preserved
 * during the load window because the children are still in the DOM tree —
 * they're just invisible. This avoids the page jump that conditional
 * rendering causes.
 *
 * Use this around any block whose contents could mislead the user when
 * the dependent data hasn't arrived yet (empty-state messages, CMS labels,
 * stale-cache snapshots, etc.).
 */
export default function FadeIn({ ready, children, className = "", style = {} }) {
  return (
    <div
      className={className}
      style={{
        opacity: ready ? 1 : 0,
        visibility: ready ? "visible" : "hidden",
        transition: "opacity 140ms ease-out",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
